import axios from '@/plugins/axios';

/**
 * Obtiene los datos del usuario autenticado actual (incluyendo sus roles)
 * desde el backend de Laravel.
 */
export const fetchCurrentUser = async () => {
    try {
        const response = await axios.get('/user');

        return response.data;
    } catch (error) {
        console.error("Error fetching current user:", error);
        throw error;
    }
};